import { Suspense } from 'react'
import { EVaultPositions } from '@/features/vaults/components/EVaultPositions'
import { EVaultsSkeleton } from '@/features/vaults/components/skeleton/EVaultsSkeleton'

export function EarnDashboard() {
  return (
    <Suspense fallback={<EVaultsSkeleton />}>
      <EVaultPositions />
    </Suspense>
  )
}
